var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2502_48784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1716 3.375H2.04883C1.97148 3.375 1.9082 3.43828 1.9082 3.51562V4.5C1.9082 4.57734 1.97148 4.64062 2.04883 4.64062H16.1716C16.2489 4.64062 16.3122 4.57734 16.3122 4.5V3.51562C16.3122 3.43828 16.2489 3.375 16.1716 3.375ZM9.4216 8.36719H2.04883C1.97148 8.36719 1.9082 8.43047 1.9082 8.50781V9.49219C1.9082 9.56953 1.97148 9.63281 2.04883 9.63281H9.4216C9.49894 9.63281 9.56222 9.56953 9.56222 9.49219V8.50781C9.56222 8.43047 9.49894 8.36719 9.4216 8.36719Z",
    fill: "#000022",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.04883 13.3594H9.48488C9.56222 13.3594 9.6255 13.4227 9.6255 13.5V14.4844C9.6255 14.5617 9.56222 14.625 9.48488 14.625H2.04883C1.97148 14.625 1.9082 14.5617 1.9082 14.4844V13.5C1.9082 13.4227 1.97148 13.3594 2.04883 13.3594Z",
    fill: "#000022",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2854 11.0931L16.0043 14.812C16.1303 14.9379 16.3457 14.8487 16.3457 14.6705V7.23284C16.3457 7.05466 16.1303 6.96543 16.0043 7.09142L12.2854 10.8103C12.2073 10.8884 12.2073 11.015 12.2854 11.0931Z",
    fill: "#000022",
    fillOpacity: 0.85
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2502_48784"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFold);
export default __webpack_public_path__ + "static/media/fold.7501ca06ac0e84edc3469cdc9bb22540.svg";
export { ForwardRef as ReactComponent };